export default "__VITE_ASSET__DVFgGBnb__"